<template>
  <entities-stats :incoming='incoming' :outcoming='outcoming'/>
</template>

<script>
import EntitiesStats from '@/components/common/EntitiesStats.vue'
export default {
  components: {
    EntitiesStats
  },
  data () {
    return {
      incoming: {
        module: 'orderIn',
        route: 'orders_in',
        items: 'orders'
      },
      outcoming: {
        module: 'orderOut',
        route: 'orders_out',
        items: 'orders'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
